import React from 'react';
import Relay from 'react-relay';

class LockersPage extends React.Component {
  constructor(props) {
    super(props);
    const initialLockerStates = {};
    const lockers = [
      'A1', 'B1', 'C1', 'D1',
      'A2', 'B2', 'C2', 'D2',
      'A3', 'B3', 'C3', 'D3',
      'A4', 'B4', 'C4', 'D4'
    ];
    
    lockers.forEach((name, index) => {
      initialLockerStates[name] = {
        isOpen: false,
        externalId: index
      };
    });
    
    this.state = {
      lockers: initialLockerStates
    };
  }

  handleLockerClick = (lockerName) => {
    const locker = this.state.lockers[lockerName];
    if (!locker) return;

    const lockid = locker.externalId;
    const groupid = 0;
    const endpoint = `/api/lockers/open-lock?lockid=${lockid}&groupid=${groupid}`;

    const username = 'Sportunity';
    const password = 'zI4pN5wA8uK9aR1b';
    const authString = btoa(`${username}:${password}`);

    fetch(endpoint, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Basic ${authString}`
      }
    })
    .then((response) => {
      if (response.status === 200) {
        this.setState(prevState => ({
          lockers: {
            ...prevState.lockers,
            [lockerName]: {
              ...prevState.lockers[lockerName],
              isOpen: true
            }
          }
        }));
      } else {
        console.error(`Failed to open locker ${lockerName}:`, response.status);
        alert(`Failed to open locker ${lockerName}`);
      }
    })
    .catch((error) => {
      console.error(`Error opening locker ${lockerName}:`, error);
      alert(`Error opening locker ${lockerName}`);
    });
  }

  render() {
    const lockers = [
      'A1', 'B1', 'C1', 'D1',
      'A2', 'B2', 'C2', 'D2',
      'A3', 'B3', 'C3', 'D3',
      'A4', 'B4', 'C4', 'D4'
    ];

    const buttonStyle = {
      margin: '10px',
      padding: '10px 20px',
      fontSize: '16px',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      minWidth: '120px'
    };

    const closedButtonStyle = {
      ...buttonStyle,
      backgroundColor: '#dc3545',
      color: 'white'
    };

    const openButtonStyle = {
      ...buttonStyle,
      backgroundColor: '#28a745',
      color: 'white'
    };

    return (
      <div className="container" style={{marginTop: 20, padding: '20px'}}>
        <h2 style={{marginBottom: '30px'}}>Lockers</h2>
        <div style={{display: 'flex', flexWrap: 'wrap'}}>
          {lockers.map((lockerName) => {
            const locker = this.state.lockers[lockerName];
            const isOpen = locker ? locker.isOpen : false;
            const buttonText = isOpen ? 'Open' : 'Closed';
            const currentStyle = isOpen ? openButtonStyle : closedButtonStyle;

            return (
              <button
                key={lockerName}
                onClick={() => this.handleLockerClick(lockerName)}
                style={currentStyle}
              >
                {lockerName} - {buttonText}
              </button>
            );
          })}
        </div>
      </div>
    );
  }
}

export default Relay.createContainer(LockersPage, {
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        id
      }
    `,
  }
});



// WEBPACK FOOTER //
// ./src/pages/Locker/LockersPage.js